/**
 * @generated SignedSource<<a5d316fbd5a03c06fe0defa142497c21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScheduleDayOfMonth = "FIRST_WORKING_DAY" | "LAST_WORKING_DAY" | "DAY_1" | "DAY_15" | "LAST_DAY" | "FIRST_MONDAY" | "LAST_FRIDAY" | "%future added value";
export type ScheduleFrequency = "WEEKLY" | "BIWEEKLY" | "FOUR_WEEKLY" | "MONTHLY" | "QUARTERLY" | "%future added value";
export type ScheduleWeekday = "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY" | "%future added value";
export type SetScheduleSetEnabledInput = {
  consumer: string;
  enabled: boolean;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type scheduleMutationsSetEnabledMutation$variables = {
  input: SetScheduleSetEnabledInput;
};
export type scheduleMutationsSetEnabledMutation$data = {
  readonly setScheduleSetEnabled: {
    readonly scheduleSet: {
      readonly id: string;
      readonly consumer: string;
      readonly enabled: boolean;
      readonly schedules: ReadonlyArray<{
        readonly id: string;
        readonly scheduleId: string;
        readonly frequency: ScheduleFrequency;
        readonly dayOfMonth: ScheduleDayOfMonth | null;
        readonly weekdays: ReadonlyArray<ScheduleWeekday>;
        readonly timeOfDay: string;
        readonly timezone: string;
      }>;
    } | null;
  } | null;
};
export type scheduleMutationsSetEnabledMutation = {
  variables: scheduleMutationsSetEnabledMutation$variables;
  response: scheduleMutationsSetEnabledMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetScheduleSetEnabledPayload",
    "kind": "LinkedField",
    "name": "setScheduleSetEnabled",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleSet",
        "kind": "LinkedField",
        "name": "scheduleSet",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consumer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedules",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frequency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dayOfMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekdays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeOfDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "scheduleMutationsSetEnabledMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "scheduleMutationsSetEnabledMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ad4fb0acc71f561036606ae003b1f499",
    "id": null,
    "metadata": {},
    "name": "scheduleMutationsSetEnabledMutation",
    "operationKind": "mutation",
    "text": "mutation scheduleMutationsSetEnabledMutation(\n  $input: SetScheduleSetEnabledInput!\n) {\n  setScheduleSetEnabled(input: $input) {\n    scheduleSet {\n      id\n      consumer\n      enabled\n      schedules {\n        id\n        scheduleId\n        frequency\n        dayOfMonth\n        weekdays\n        timeOfDay\n        timezone\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9d50bdddfd17e35ab120331a5cbc9a6";

export default node;
